import {
  Alert,
  AlertDescription,
  AlertIcon,
  Box,
  Button,
  Stack,
} from '@chakra-ui/react'
import React from 'react'
import { Link } from 'react-router-dom'

const ProfileIncompleteAlert: React.FC = () => {
  return (
    <Stack spacing={3}>
      <Alert status='warning' variant='left-accent'>
        <AlertIcon />
        <AlertDescription>
          You can't start doing reports until you create your profile.
        </AlertDescription>
      </Alert>
      <Box>
        <Link to='/profile'>
          <Button colorScheme='gray'>Create Profile</Button>
        </Link>
      </Box>
    </Stack>
  )
}

export default ProfileIncompleteAlert
